import { Component, Output, EventEmitter } from '@angular/core';
import { SignupForm } from '../signup-form/signup-form';
import { ApplyForBeta } from '../apply-for-beta/apply-for-beta';

@Component({
  selector: 'app-pitch-deck-static',
  standalone: true,
  imports: [SignupForm, ApplyForBeta],
  templateUrl: './pitch-deck-static.html',
  styleUrls: ['./pitch-deck-static.scss'],
})
export class PitchDeckStatic {
  @Output() getStarted = new EventEmitter<void>();

  onGetStarted() {
    this.getStarted.emit();
  }
}
